import { Zap, Users, Puzzle, Home } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";

const beneficios = [
  {
    icon: Zap,
    title: "Exprésate en el momento",
    text: "Comparte una idea, una preocupación, una obsesión o una situación cotidiana cuando aparezca.",
  },
  {
    icon: Users,
    title: "Habla con personas afines",
    text: "Conoce a miembros que también conviven con las altas capacidades y entienden cómo funciona tu mente.",
  },
  {
    icon: Puzzle,
    title: "Deja de explicarte desde cero",
    text: "Entra en un entorno donde muchas experiencias, patrones y contradicciones ya resultan familiares.",
  },
  {
    icon: Home,
    title: "Encuentra pertenencia",
    text: "Construye conexiones con personas que valoran la profundidad, la curiosidad y la autenticidad.",
  },
];

export const Valor = () => (
  <section className="bg-[#0B1120] px-5 py-24 md:py-32">
    <div className="mx-auto max-w-[1100px]">
      <Reveal>
        <ChapterLabel number="02" testId="chapter-valor" />
        <h2 className="max-w-3xl text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          No es otro curso. Es un lugar al que puedes acudir cada día.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2" data-testid="valor-cards">
        {beneficios.map((b, i) => (
          <Reveal key={b.title} delay={0.06 * i} className="h-full">
            <div className="flex h-full flex-col rounded-2xl border border-[#22304D] bg-[#131D33] p-8 transition-[transform,border-color] duration-200 hover:-translate-y-1 hover:border-[#8B7CF6]/40">
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#8B7CF6]/10 text-[#8B7CF6]">
                <b.icon className="h-5 w-5" strokeWidth={1.5} />
              </div>
              <h3 className="mt-5 text-lg font-semibold leading-snug text-[#F5F1EA]">
                {b.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-[#9AA6BE]">
                {b.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
